// src/helpers/rutaTipos.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "http://backretiro360.us-3.evennode.com"; // 👈 BACK, no FRONT
const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({ baseURL: BASE_URL });

const p = (s) => String(s || "").replace(/^\/+/, "");

const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

const debugUrl = (url, params) => console.log("👉 URL:", API.getUri({ url, params }));

export const getTipoByCliente = async (codcli) => {
  const url = p(`tipo/cliente/${codcli}`);
  debugUrl(url);

  try {
    const { data } = await API.get(url, auth());
    return data; // { ok:true, tipo:{...} }
  } catch (err) {
    // ✅ si no existe registro para ese cliente, lo tratamos como "vacío"
    if (err?.response?.status === 404) return { ok: false, tipo: null };
    throw err;
  }
};

export const upsertTipoByCliente = async (codcli, payload) => {
  const url = p(`tipo/cliente/${codcli}`);
  debugUrl(url);
  const { data } = await API.put(url, payload, auth());
  return data; // { ok, tipo }
};